import React from "react";
import {
  Box,
  Grid,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  CustomBoxFullWidth,
  CustomStackFullWidth,
} from "../../styled-components/CustomStyles.style";
import CustomImageContainer from "../CustomImageContainer";
import CustomContainer from "../container";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import ManageSearch from "../header/second-navbar/ManageSearch";

const SearchHeroSection = ({ configData, token, zoneid }) => {
  const theme = useTheme();
  const isXSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const router = useRouter();
  
  // Get search query from URL
  const searchValue = router.query?.searchValue || "";

  return (
    <CustomContainer>
      <CustomBoxFullWidth
        sx={{
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
          marginTop: { xs: "1rem", sm: "1.5rem", md: "2rem" },
          marginBottom: { xs: "1rem", sm: "1.5rem", md: "2rem" },
          borderRadius: "16px",
          position: "relative",
          overflow: "hidden",
          minHeight: { xs: "120px", sm: "150px", md: "180px" },
        }}
      >
        {/* Background Pattern */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "100%",
            height: "100%",
            background: `linear-gradient(135deg, ${alpha(
              theme.palette.primary.main,
              0.05
            )} 0%, ${alpha(theme.palette.primary.main, 0.15)} 100%)`,
            "&::before": {
              content: '""',
              position: "absolute",
              top: "-50%",
              right: "-20%",
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              background: alpha(theme.palette.primary.main, 0.1),
            },
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: "-30%",
              left: "-10%",
              width: "150px",
              height: "150px",
              borderRadius: "50%",
              background: alpha(theme.palette.secondary.main, 0.08),
            },
          }}
        />

        <Grid container alignItems="center" sx={{ position: "relative", zIndex: 1 }}>
          <Grid item xs={12}>
            <Box sx={{ padding: { xs: "1.5rem", sm: "2rem", md: "2.5rem" } }}>
              <CustomStackFullWidth spacing={3} alignItems="center">
                <CustomStackFullWidth spacing={1} alignItems="center">
                  <Typography
                    variant="h1"
                    sx={{
                      color: theme.palette.primary.main,
                      fontSize: { xs: "24px", sm: "32px", md: "40px" },
                      fontWeight: "bold",
                      lineHeight: 1.2,
                      textAlign: "center",
                    }}
                  >
                    {searchValue
                      ? t("Search Results")
                      : t("Find What You Need")}
                  </Typography>
                  
                  {searchValue && (
                    <Typography
                      sx={{
                        color: alpha(theme.palette.neutral[600], 0.8),
                        fontSize: { xs: "14px", sm: "16px", md: "18px" },
                        fontWeight: "400",
                        textAlign: "center",
                      }}
                    >
                      {t("Showing results for")} "{searchValue}"
                    </Typography>
                  )}
                  
                  {!searchValue && (
                    <Typography
                      sx={{
                        color: alpha(theme.palette.neutral[600], 0.8),
                        fontSize: { xs: "14px", sm: "16px", md: "18px" },
                        fontWeight: "400",
                        textAlign: "center",
                      }}
                    >
                      {t("Discover amazing products and stores")}
                    </Typography>
                  )}
                </CustomStackFullWidth>
                
                {/* Search Bar */}
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "600px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ManageSearch maxwidth="true" token={token} zoneid={zoneid} />
                </Box>
              </CustomStackFullWidth>
            </Box>
          </Grid>
        </Grid>
      </CustomBoxFullWidth>
    </CustomContainer>
  );
};

export default SearchHeroSection;